import React from "react";
import Link from "next/link";

const LowIncomeHousingHelp = () => {
    return (
        <div className="space-y-4">
            <h2 className="text-xl font-semibold">Low-Income Housing Assistance</h2>
            <p>We can help you explore various financial assistance options:</p>
            <div className="grid gap-4">
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-medium">Available Programs</h3>
                    <ul className="list-disc pl-5 text-gray-800 mt-1 space-y-2">
                        <li>Low Income Housing</li>
                        <li>HUD Senior Housing</li>
                        <li>State and Local Assistance Programs</li>
                        <li>Medicaid Assisted Living Waiver Program</li>
                        <li>War Veterans Aid & Assistance</li>
                    </ul>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-medium">Contact Us</h3>
                    <p className="text-gray-800 mt-1">
                        Visit our{" "}
                        <Link
                            href="/contact-us"
                            className="text-primary-600 hover:text-primary-800 underline font-bold"
                        >
                            contact page
                        </Link>{" "}
                        and an advisor will contact you.
                    </p>
                </div>
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-medium">Call Us</h3>
                    <p className="text-gray-800 mt-1">
                        Reach us at{" "}
                        <a
                            href="tel:6127877533"
                            className="text-primary-600 hover:text-primary-800 font-bold"
                        >
                            (612) PURPLE-3
                        </a>{" "}
                        or{" "}
                        <a
                            href="tel:6127877533"
                            className="text-primary-600 hover:text-primary-800 font-bold"
                        >
                            (612) 787-7533
                        </a>
                    </p>
                </div>
            </div>
            <p className="text-sm text-gray-500 mt-4">
                Our specialists are available during business hours to guide you through the
                application process.
            </p>
        </div>
    );
};

export default LowIncomeHousingHelp;
